import {useLazyQuery} from "@apollo/client";
import {contentService} from "../api/contentService";
import {OffCanvasVariableType} from "../definitions/types";
import {OffCanvasProductModel} from "../models/domain/offCanvasProductModel";

export const useOffCanvasProductQuery = () => {
    const [getOffCanvasProductQuery] = useLazyQuery(contentService.product.offCanvas);

    const queryAsync = async (variables: OffCanvasVariableType) => {
        const response = await getOffCanvasProductQuery({variables});
        return response.data?.product ? new OffCanvasProductModel(response.data.product) : null;
    }

    return {
        query: queryAsync
    }
}